import { useState } from "react";
import cn from "classnames";
import { IPeriodSkills, ITeamMemberPeriodSkills } from "@/service/review-period";
import { Loader } from "@/shared/ui";
import { getRatingColor } from "@/service/team-assessment";
import { ComparisonToggle, DimensionItem } from "./_components";

export type ComparisonMode = "current" | "next";

interface SkillsMatrixTableProps {
  skills?: IPeriodSkills | ITeamMemberPeriodSkills;
  isLoading?: boolean;
  valueDelivered?: string;
}

export const SkillsMatrixTable = ({ skills, isLoading, valueDelivered }: SkillsMatrixTableProps) => {
  const [comparisonMode, setComparisonMode] = useState<ComparisonMode>("current");

  if (isLoading) {
    return (
      <div className="flex w-full items-center justify-center py-6">
        <Loader />
      </div>
    );
  }

  if (!skills?.dimensions?.length) {
    return null;
  }

  return (
    <div className="flex flex-col">
      <div className="mb-2 flex justify-end">
        <ComparisonToggle value={comparisonMode} onChange={setComparisonMode} />
      </div>
      <div className="text-eerie-black grid grid-cols-[1fr_216px_60px_40px] gap-4 border-b-2 border-gray-300 pb-2 text-xs font-bold">
        <div>Skills</div>
        <div className="flex items-center justify-between">
          {[0, 1, 2, 3, 4, 5].map((num) => (
            <span key={num} className="w-4 text-center">
              {num}
            </span>
          ))}
        </div>
        <div>Expected</div>
        <div>Actual</div>
      </div>
      <div className="flex flex-col">
        {skills?.dimensions?.map((dimension, index) => (
          <DimensionItem key={index} dimension={dimension} comparisonMode={comparisonMode} />
        ))}
        {valueDelivered && (
          <div className="border-b border-gray-300 last:border-b-0">
            <div className="flex items-center justify-between gap-4 py-1">
              <div className="text-eerie-black flex items-center gap-2 text-sm font-bold">
                <span>3. Value Delivered:</span>
                <span className={cn(getRatingColor(valueDelivered || ""))}>{valueDelivered}</span>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};
